import {
  // GET_ADMIN_COMMENT, GET_ADMIN_COMMENT_START, GET_ADMIN_COMMENT_FAIL,

  GET_CW_ASSIGNMENTS_START,
  GET_CW_ASSIGNMENTS,
  GET_IMAGE_START,
  GET_IMAGE,
  GET_IMAGE_FAIL,
  GET_IPADDRESS_START,
  GET_IPADDRESS,
  GET_IPADDRESS_FAIL,
  GET_TIMECARD_START,
  GET_TIMECARD,
  GET_TIMECARD_FAIL,
  GET_CLIENT_NAMES,
  GET_CLIENT_NAMES_START,
  GET_CLIENT_NAMES_FAIL,
  GET_TIMECARD_WEEKS,
  GET_TIMECARD_WEEKS_START,
  GET_TIMECARD_WEEKS_FAIL,
  GET_JOB_NAMES,
  GET_JOB_NAMES_START,
  GET_JOB_NAMES_FAIL,
  GET_EMPLOYEE_NAMES,
  GET_EMPLOYEE_NAMES_START,
  GET_EMPLOYEE_NAMES_FAIL,
  SAVE_FILTER_DATA
} from "./actionTypes";
import { instance } from "../utilities/services";

export const saveFilterData = (filterData) =>{
  return {
      type: SAVE_FILTER_DATA,
      filterData
  }
}

export const fetchTimecardWeeks = (supervisorId) => async dispatch => {
  try {
    dispatch({ type: GET_TIMECARD_WEEKS_START });

    //Thoughtfocus
    // const response = await instance.get(`Timecard/timeCardWeekDropDown/${supervisorId}`);
    // dispatch({ type: GET_TIMECARD_WEEKS, timecardWeeks: response });
    // return response;
    //

    //Change to include last month-ish of timecard weeks, grabbed from admin service
    const response = await instance.get(`Admin/adminTimeCardDropDown`);
    response.data.TimeCardWeeksDropDown = response.data.TimeCardWeeks.slice(0, 5);
    dispatch({ type: GET_TIMECARD_WEEKS, timecardWeeks: response });
    return response;
    //
  } catch (error) {
    console.log(error);
    dispatch({ type: GET_TIMECARD_WEEKS_FAIL, error });
  }
};

export const fetchClientNames = () => async dispatch => {
  try {
    dispatch({
      type: GET_CLIENT_NAMES_START
    });
    const response = await instance.get(`Timecard/clientDropDown/83960`);
    dispatch({
      type: GET_CLIENT_NAMES,
      clientNames: response
    });
  } catch (error) {
    dispatch({ type: GET_CLIENT_NAMES_FAIL, error });
  }
};

export const fetchJobNames = (supervisorId) => async dispatch => {
  try {
    dispatch({
      type: GET_JOB_NAMES_START
    });
    const response = await instance.get(`Timecard/jobDropDown/${supervisorId}`);
    dispatch({
      type: GET_JOB_NAMES,
      jobNames: response
    });
  } catch (error) {
    dispatch({ type: GET_JOB_NAMES_FAIL, error });
  }
};

export const fetchEmployeeNames = () => async dispatch => {
  try {
    dispatch({
      type: GET_EMPLOYEE_NAMES_START
    });
    const response = await instance.get(`Timecard/employeeDropDown/83960`);
    dispatch({
      type: GET_EMPLOYEE_NAMES,
      employeeNames: response
    });
  } catch (error) {
    dispatch({ type: GET_EMPLOYEE_NAMES_FAIL, error });
  }
};


export const fetchTimecard = (timecardId) => async(dispatch) =>{
  try {
      dispatch({type: GET_TIMECARD_START});
      const response = await instance.get(`Timecard/employeeTimeCardSaveSubmitView/${timecardId}`);
      dispatch({type: GET_TIMECARD, timecard:response })
  } catch (error) {
      console.log(error)
      dispatch({type: GET_TIMECARD_FAIL, error })
  }
}